import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { FeaturesGrid } from './components/FeaturesGrid';
import { RecipesBreakdown } from './components/RecipesBreakdown';
import { BeyondRecipes } from './components/BeyondRecipes';
import { BenefitsSection } from './components/BenefitsSection';
import { Testimonials } from './components/Testimonials';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-gray-200 font-sans selection:bg-earth-amber selection:text-dark-900" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <FeaturesGrid data-id="element-4" />
      <RecipesBreakdown data-id="element-5" />
      <BeyondRecipes data-id="element-6" />
      <BenefitsSection data-id="element-7" />
      <Testimonials data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}